<template>
    <div class="timeline-event-quotation">
        <div class="timeline-event-quotation__subtitle">
            {{ subtitle }}
        </div>

        <event-treatment-detail :doctor_names="doctor_names" @note="note" @done="done" @assign="assign" v-for="treatment in approved_treatments" :key="treatment.id" :treatment="treatment"
            :event="event" @appointment="appointment"></event-treatment-detail>
    </div>
</template>

<script>
export default {
    props: ['event', 'entity', 'doctor_names'],
    data() {
        return {

        }
    },
    computed: {
        approved_treatments() {
            if (!this.entity.treatments) return [];
            return this.entity.treatments.filter(t => t.is_approved);
        },
        subtitle() {
            if (this.entity.notes && this.entity.notes !== '') {
                return this.entity.notes;
            }
            return 'TRATAMIENTOS';
        },
        ...mapGetters(['msgwindow', 'errorwindow', 'clinic'])
    },
    methods: {
        assign(treatment) {
            this.$emit('assign', this.event, treatment);
        },
        note(treatment) {
            this.$emit('note', this.event, treatment);
        },
        done(treatment) {
            this.$emit('done', this.event, treatment);
        },
        appointment(treatment) {
            this.$emit('appointment', this.event, treatment);
        },
    },
    mounted() {
    }
}
</script>

<style lang="scss">
.timeline-event-quotation {

    &__subtitle {
        margin-top: 15px;
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 5px;
    }

}
</style>
